'use client';

import React from 'react';
import ProgressBar from '../common/ProgressBar';
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronsUp } from '@fortawesome/pro-duotone-svg-icons';
import { getSourcePath } from '@/rewrites';
import { useAccount } from '@/hooks/useAccount';

type SubscriptionLimitsCardProps = {
  type: 'ACCOUNTS' | 'AGENTS' | 'QUERIES' | 'RESULTS' | 'SHORTLISTS' | 'QUESTIONS';
};

const SubscriptionLimitsCard: React.FC<SubscriptionLimitsCardProps> = ({ type }) => {
  const { usage, limits, currentTier } = useAccount();

  if (!usage || !limits) return null;

  const current = usage?.[type];
  const total = limits?.[type];
  const cappedCurrent = Math.min(current, total);

  const typeLabelMap = {
    ACCOUNTS: 'Nutzerkonten',
    AGENTS: 'Suchprofile',
    QUERIES: 'Suchanfragen',
    RESULTS: 'Suchergebnisse',
    SHORTLISTS: 'Merklisten',
    QUESTIONS: 'KI Fragen',
  };

  return (
    <div className="flex w-full flex-col gap-2 rounded-lg bg-base-200 p-4">
      <div className="flex items-center justify-between">
        <span className="text-base font-medium">{currentTier}</span>
        <Link
          href={getSourcePath('/subscription')}
          className="button flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-xs font-medium text-primary-content"
        >
          <FontAwesomeIcon icon={faChevronsUp} className="h-4 w-4" />
          <span>Upgrade</span>
        </Link>
      </div>
      <div className="flex items-center justify-between gap-2 text-xs font-normal">
        <span>{typeLabelMap[type]}</span>
        <span>{`${current}/${total}`}</span>
      </div>
      <ProgressBar min={0} max={total} value={cappedCurrent} />
    </div>
  );
};

export default SubscriptionLimitsCard;
